import { Component, AfterViewInit, OnDestroy, } from '@angular/core';
import { NgForm } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { TdLoadingService, TdDialogService, } from '@covalent/core';
import { MdSelect } from '@angular/material';
import { Observable } from 'rxjs/Observable';
import { Observer } from 'rxjs';

import { JuicioDiagnosticoService, MasterService, LoginService, } from '../../../../../services';

import { JuicioDiagnostico } from '../../../../../models';

@Component({
    selector: 'qs-juiciodiagnosticodetalle',
    styleUrls: ['./juiciodiagnosticodetalle.component.scss'],
    templateUrl: './juiciodiagnosticodetalle.component.html',
    viewProviders: [JuicioDiagnosticoService, MasterService, ],
})

export class JuicioDiagnosticoDetalleComponent implements AfterViewInit, OnDestroy {

    private mode: string;
    private title: string;

    private idPaciente: string;

    private juicioDiagnostico: any;
    private oldJuicioDiagnostico: any;
    private filtrando: boolean = false;

    public masterDiagnosticos: any[];
    public valueDiagnostico: any[];
    public filteredDiagnosticos: any[];
    public asignedDiagnosticos: any[];
    public addDiagnosticos: boolean = true;
    public delDiagnosticos: boolean = true;

    public juicioDiagnosticoForm: NgForm;

    constructor(private _loadingService: TdLoadingService,
        private _dialogService: TdDialogService,
        private _router: Router,
        private _route: ActivatedRoute,
        private _master: MasterService,
        private _juicioDiagnosticoService: JuicioDiagnosticoService,
        private _loginService: LoginService, ) {
        this.idPaciente = this._loginService.consulta.numeroExpediente;
        this.juicioDiagnostico = new JuicioDiagnostico();
        this.oldJuicioDiagnostico = new JuicioDiagnostico();
        if (this._loginService.transient) {
            this.mode = 'del';
            this.title = 'Consultar';
            this.juicioDiagnostico = this._loginService.transient;
            this.valueDiagnostico = [{
                id: this.juicioDiagnostico.proceso,
                cie9: this.juicioDiagnostico.cie9,
                literal: this.juicioDiagnostico.descripcion,
                diagnos: this.juicioDiagnostico.numero,
            }];
            this.asignedDiagnosticos = [ this.juicioDiagnostico.descripcion, ];
            /*this._master.obtenerMasterDiagnosticosPorId(this.juicioDiagnostico.numero).subscribe((res: any) => {
                if (!res.error) {
                    this.masterDiagnosticos = res.respuesta.enfermedades || [];
                    this.valueDiagnostico = this.masterDiagnosticos;
                    this.asignedDiagnosticos = [this.valueDiagnostico[0].literal];
                } else {
                    this._loginService.mostrarMensaje(res.error.mensaje, 'OK', 3000);
                }
            }, (error: Error) => {
                this.filtrando = false;
            });*/
            this.addDiagnosticos = false;
            this.delDiagnosticos = false;
        } else {
            this.mode = 'add';
            this.title = 'Añadir';
        }
    }

    ngAfterViewInit(): void {
        this._loadingService.register('juiciodiagnostico.load');
        this._loadingService.resolve('juiciodiagnostico.load');
    }

    save(form: NgForm): void {
        let accion: string;
        let fecha: Date = new Date();
        let message: string = '';
        let error: string = '';
        let messages: string[] = [
            'Juicio diagnóstico añadido correctamente.', 'Error añadiendo juicio diagnóstico.',
            'Juicio diagnóstico borrado correctamente.', 'Error borrando juicio diagnóstico', ];
        let hora: string = fecha.getHours() + ':' + fecha.getMinutes() + ':' + fecha.getSeconds();
        switch (this.mode) {
            case 'del':
                accion = 'B';
                message = messages[2];
                error = message[3];
                break;
            case 'add':
                accion = 'I';
                message = messages[0];
                error = messages[1];
                break;
            default: break;
        }

        if (form.valid) {
            this._loadingService.register();
            if (this.mode === 'add') {
                let params: any = {
                    lVisita: this._loginService.consulta.visita,
                    lContador: this._loginService.consulta.numeroExpediente,
                    lDniMed: this._loginService.profesional.Dni,
                    lCias: this._loginService.cias,
                    lCip: this._loginService.consulta.cip,
                    lDiagnos: { string: this.valueDiagnostico[0].diagnos },
                    iDescripcion: this.valueDiagnostico[0].literal,
                    iIdModulo: 0,
                    iIDEpisodio: '',
                    iNumVisitaAnterior: '',
                };
                this.mode = 'save';
                this._juicioDiagnosticoService.guardarJuicioDiagnostico(params).subscribe((res: any) => {
                    if (res) {
                        this._loginService.mostrarMensaje(message, 'OK', 6000);
                        this._loadingService.resolve();
                        this._router.navigate(['/main/consulta/' + this.idPaciente + '/hojadeseguimiento', {
                            outlets: { hojadeseguimiento: ['juicio'] } }]);
                    } else {
                        this._loginService.mostrarMensaje(error, 'OK', 6000);
                        this._loadingService.resolve();
                    }
                }, (resError: Error) => {
                    this._loginService.mostrarMensaje('Error procesando el alta', 'OK', 6000);
                    this._loadingService.resolve();
                });
            } else {
                // Modo borrado
                let params: any = {
                    iNumExpediente: this._loginService.consulta.numeroExpediente,
                    iNumVisita: this._loginService.consulta.visita,
                    iDiagnos: this.juicioDiagnostico.numero,
                    iDniBorrado: this._loginService.profesional.Dni,
                    iMotivoBorrado: 'HCIONCLOUD',
                    iProceso: this.juicioDiagnostico.proceso,
                };
                this._juicioDiagnosticoService.borrarDiagnostico(params).subscribe((res: any) => {
                    if (res) {
                        this._loginService.mostrarMensaje(message, 'OK', 6000);
                        this._loadingService.resolve();
                        this._router.navigate(['/main/consulta/' + this.idPaciente + '/hojadeseguimiento', {
                            outlets: { hojadeseguimiento: ['juicio'] } }]);
                    } else {
                        this._loginService.mostrarMensaje(error, 'OK', 6000);
                        this._loadingService.resolve();
                    }
                }, (resError: Error) => {
                    this._loginService.mostrarMensaje('Error procesando la modificación.', 'OK', 6000);
                    this._loadingService.resolve();
                });
            }
        }
    }

    getDiagnosticos(value: string): void {
        if (value.length >= 3) {
            this.filtrando = true;
            this._master.obtenerMasterDiagnosticos(value).subscribe((res: any) => {
                if (!res.error) {
                    this.masterDiagnosticos = res.respuesta.enfermedades || [];
                    this.filteredDiagnosticos = this.masterDiagnosticos.map((en: any, index: any, enf: any[]) => {
                        return en.literal;
                    });
                    this.asignedDiagnosticos = this.filteredDiagnosticos;
                    this.filtrando = false;
                } else {
                    this._loginService.mostrarMensaje(res.error.mensaje, 'OK', 3000);
                    this.filtrando = false;
                }
            }, (error: Error) => {
                this.filtrando = false;
            });
        }
    }

    addDiagnostico(value: any): void {
        this.addDiagnosticos = false;
        this.valueDiagnostico = this.masterDiagnosticos.filter((dia: any) => { return dia.literal === value; });
        this.masterDiagnosticos = undefined;
        this.filteredDiagnosticos = undefined;
        this.filtrando = false;
    }

    removeDiagnostico(value: any): void {
        this.masterDiagnosticos = undefined;
        this.filteredDiagnosticos = undefined;
        this.valueDiagnostico = undefined;
        this.asignedDiagnosticos = undefined;
        this.addDiagnosticos = true;
        this.filtrando = false;
    }

    /*
    canDeactivate(): Promise<boolean> | boolean {
      if ((this.oldAnamnesi.principioActivo == this.anamnesi.principioActivo) &&
        (this.oldAnamnesi.fecha.getDate() == this.anamnesi.fecha.getDate()) &&
        (this.oldAnamnesi.estado == this.anamnesi.estado) &&
        (this.oldAnamnesi.tipo == this.anamnesi.tipo)) {
        return true;
      } else {
        if (this.mode != 'save') {
          return new Promise((resolve) => {
            this._dialogService.openConfirm({
              message: 'Si pulsa aceptar, se perderán los datos introducidos.',
              title: '¿Desea abandonar el alta de anamnesi?',
              acceptButton: 'Aceptar',
              cancelButton: 'Cancelar'
            }).afterClosed().subscribe((accept: boolean) => {
              if (accept) {
                resolve(true);
              } else {
                resolve(false);
              }
            });
          });
        } else {
          return true;
        }
      }
    }*/

    ngOnDestroy(): void {
        this._loginService.transient = '';
    }
}



// WEBPACK FOOTER //
// ./src/app/consulta/hojadeseguimiento/juiciodiagnostico/juiciodiagnosticodetalle/juiciodiagnosticodetalle.component.ts